import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';

import { MaintenanceRepository } from '~shared/store/maintenance/maintenance.repository';
import { AuthService } from '~core/services/auth.service';
import { UserRole, UserType } from '~shared/enums/user.enum';

@UntilDestroy()
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	private maintenanceLogoutInProgress = false;

	constructor(
		private readonly router: Router,
		private readonly maintenanceRepository: MaintenanceRepository,
		private readonly authService: AuthService,
	) {}

	public ngOnInit(): void {
		// React whenever the flag or the signed-in user changes (pushed over the
		// WebSocket, fetched at startup, or fetched on login — never polled).
		combineLatest([
			this.maintenanceRepository.isInMaintenance$,
			this.authService.currentUser$,
		])
			.pipe(untilDestroyed(this))
			.subscribe(([inMaintenance, user]) => {
				const [path, query = ''] = this.router.url.split('?');
				const onMaintenancePage = path === '/maintenance';
				const isPreview = new URLSearchParams(query).has('preview');

				// A preview tab stays put regardless.
				if (isPreview) {
					return;
				}

				// Admins bypass the gate; never strand them on the public page.
				const isAdmin = user?.userType === UserType.INTERNAL && user?.userRole === UserRole.ADMIN;
				if (isAdmin) {
					if (onMaintenancePage) {
						void this.router.navigateByUrl('/');
					}
					return;
				}

				if (inMaintenance) {
					if (user) {
						// Signed-in non-admin: sign out of Cognito and land on the notice.
						if (!this.maintenanceLogoutInProgress) {
							this.maintenanceLogoutInProgress = true;
							void this.authService.forceMaintenanceLogout();
						}
					} else if (!onMaintenancePage) {
						// Logged-out visitor: just show the notice.
						void this.router.navigateByUrl('/maintenance');
					}
				} else if (onMaintenancePage) {
					void this.router.navigateByUrl('/');
				}
			});
	}
}
